import { RouteObject } from "react-router-dom";
import PrivacyPolicyPage from "./pages/privacy-policy";
import TermsAndConditionsPage from "./pages/terms-and-conditions";

const LegalInformationRoute = "/legal-information";
export const TermsAndConditionsRoute =
	LegalInformationRoute + "/terms-and-conditions";
export const PrivacyPolicyRoute = LegalInformationRoute + "/privacy-policy";

const route: RouteObject = {
	path: LegalInformationRoute,
	children: [
		{
			path: TermsAndConditionsRoute,
			Component: TermsAndConditionsPage,
		},
		{
			path: PrivacyPolicyRoute,
			Component: PrivacyPolicyPage,
		},
	],
};

export default route;
